import Client from '@gocanvas/client'
import axios from 'axios'

import { useSelector, useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import ErrorModal from './ErrorModal'
import { actions, lib, selectors } from '@gocanvas/client'
const {
  toggleInteractiveClient,
  initializeClientEntries,
  setSubmitInProgress,
  setSubmissionSuccessful,
} = actions
const { conditionalScreenFilter } = lib
const {
  entriesSelector,
  clientEntriesSelector,
  conditionsSelector,
  sectionPreviewSelector,
  formSelector,
} = selectors

import {
  assembleSubmission,
  annotateValidPreviewEntries,
} from 'lib/clientUtils'
import { formLogoSelector } from 'apps/web-forms/store/selectors'
const { post } = axios

export const WebFormClient = ({ hasWhiteLabels }) => {
  const dispatch = useDispatch()

  const [error, setError] = useState(false)

  const entries = useSelector(entriesSelector)
  const allSheets = useSelector(sectionPreviewSelector)
  const conditions = useSelector(conditionsSelector)
  const previewEntries = useSelector(clientEntriesSelector)
  const formVersion = useSelector(formSelector).version
  const formName = useSelector(formSelector).name

  useEffect(() => {
    dispatch(toggleInteractiveClient(true))
    dispatch(initializeClientEntries({ entries }))
  }, [])

  const sheets = allSheets.filter(sheet =>
    conditionalScreenFilter(sheet, conditions, previewEntries)
  )

  const makeSubmission = async () => {
    const validSheetIds = sheets.flatMap(({ id, subSheets = [] }) => [
      id,
      ...subSheets,
    ])
    const validPreviewEntries = annotateValidPreviewEntries({
      previewEntries,
      validSheetIds,
      conditions,
    })

    dispatch(setSubmitInProgress(true))

    const formMetaData = {
      formVersion,
      guid: initialOnboardingState.appId,
      redirectUrl: initialOnboardingState.redirectUrl,
    }
    const submissionEndpoint = '/api/v3/submissions/web_forms'
    const submissionData = await assembleSubmission({
      formMetaData,
      entryData: validPreviewEntries,
    })

    return post(submissionEndpoint, submissionData)
      .then(() => {
        dispatch(setSubmissionSuccessful(true))
        if (initialOnboardingState.redirectUrl) {
          setTimeout(
            function () {
              //Start the timer
              window.location.replace(initialOnboardingState.redirectUrl) //After 1 second, set render to true
            }.bind(this),
            3000
          )
        }
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => dispatch(setSubmitInProgress(false)))
  }

  const handleCloseModal = () => {
    setError(false)
    window.location.reload()
  }

  const webFormLogo = useSelector(formLogoSelector)

  const topLevelClass = `web-form--outer-wrapper is-live-web-form full-screen-preview--container web-form--layout`
  return (
    <>
      <div className={topLevelClass}>
        <div className="web-form--container full-screen-preview--wrapper">
          {webFormLogo && (
            <div className="company-logo--container">
              <img src={webFormLogo} />
            </div>
          )}
          <div className="web-form--name">{formName}</div>
          <div className="web-form--wrapper client--container">
            <Client
              customComponents={{
                Header: () => null, // Hide the header in the client view
              }}
              onSubmit={makeSubmission}
            />
          </div>
        </div>
        {error && (
          <ErrorModal
            hasWhiteLabels={hasWhiteLabels}
            handleCloseModal={handleCloseModal}
          />
        )}
      </div>
    </>
  )
}
